import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24842c20&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./styles.scss?vue&type=style&index=0&id=24842c20&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24842c20",
  null
  
)

/* custom blocks */
import block0 from "./i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftsno%2Ffrechdax%2Fabdl-party%2Fweb%2Fwebapp%2Fsrc%2Fcomponents%2Fnewsletter-signup%2Findex.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports